export default "__VITE_ASSET__CHhTL3XP__"